require('../../modules/es.object.set-prototype-of');
var path = require('../../internals/path');

module.exports = path.Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/set-prototype-of.js
// module id = 4332
// module chunks = 25